/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

//import axios from '@/axios.js';
import firebase from '@/services/saleData';
import 'firebase/database';
import 'firebase/storage';
import moment from "moment-timezone";
import _ from 'lodash';
export default {
  // addItem({ commit }, item) {
  //   return new Promise((resolve, reject) => {
  //     axios.post("/api/data-list/products/", {item: item})
  //       .then((response) => {
  //         commit('ADD_ITEM', Object.assign(item, {id: response.data.id}))
  //         resolve(response)
  //       })
  //       .catch((error) => { reject(error) })
  //   })
  // },
  
  async fetchAgents ({ commit }) {
    //const data = localStorage.getItem('userInfo');
    //const user = JSON.parse(data);
    /*if (user.company === undefined || user.company === '') {
      await firebase.auth().signOut().then(() => {
        router.push('/login').catch(() => {})
      });
    }*/
    const user = (await firebase.database().ref(`/users`).once('value')).val();
    const usersdata = [];
    for(const x in user){
      if(usersdata[user[x].agent] === undefined) {
        usersdata[user[x].agent] = 0;
      }
      usersdata[user[x].agent]++;
    }
    firebase.database().ref().child('agents').once('value', (snapshot) => {
      let users = []; 
      snapshot.forEach((data) => {
        const user = data.val();
        user.key = data.key;
        user.user_count = (usersdata[data.key])?usersdata[data.key]:0;
        user.code = user.prefix+user.code;//("000000000" + number).slice(-Number(digit));
        users.push(user);
      });
      users = _.orderBy(users, ['createdate'],['desc']);
      commit('SET_AGENTS', users);
    });
    //commit('SET_USERS', []);
  },
  saveAgent({state,commit,dispatch}){
    if(state.agent.key){
      console.log('update');
      let username = state.agent.username;
      username.toLowerCase().trim();
      firebase.database().ref(`agents/${state.agent.key}`).update({
        name:state.agent.name,
        username,
        password:state.agent.password,
        createdate:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss")
      });
    }else{
      const username = state.agent.username.toLowerCase().trim();
      firebase.database().ref('agents').push({
        code:99,
        name:state.agent.name,
        prefix:state.agent.prefix.toUpperCase(),
        username,
        password:state.agent.password,
        createdate:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss")
      });
    }
    dispatch('fetchAgents');
    commit('SET_AGENT',{
      key:'',
      code:0,
      name:'',
      username:'',
      password:'',
      prefix:'',
    });
    commit('SET_POPUP',false);
  },
  updateUsers({state,commit}, {key,value}){
    console.log(key);
    console.log(value);
    console.log(state.users);
    const users = state.users;
    const keyUser = _.findKey(users, function(o) { return o.key === key; });
    if(keyUser){
      users.splice(keyUser, 1);
      value.key = key;
      users.splice(keyUser, 0, value);
      commit('SET_USERS', users);
    }
  },
}
